<template>
    <v-card>
        <v-toolbar color="primary">
            <v-tooltip bottom>
                <v-btn slot="activator" icon @click="fechar"><v-icon color="white">close</v-icon></v-btn>
                <span>Fechar</span>
            </v-tooltip>
            <v-toolbar-title style="color:white; font-size: 1.2em;">Anexe aqui seu comprovante de pagamento</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="text-xs-center">
            <v-layout column>
            <v-flex align-self-center>
              <template v-if="!fatura.comprovante_pagamento || imagemAnexada || arquivoAnexado">
                <div>
                    <img v-if="imagemAnexada" :src="imagemAnexada" alt="imagem do comprovante" width="300" @click="$refs.imageInput.click()">
                    <object v-if="arquivoAnexado" width="300" height="300" type="application/pdf" :data="arquivoAnexado" @click="$refs.imageInput.click()"></object>
                    <v-card v-if="!imagemAnexada && !arquivoAnexado" color="grey" width="300" height="300" @click="$refs.imageInput.click()">
                        <v-layout justify-center align-center fill-height>
                            <div class="title white--text pa-4 text-xs-center">Clique para adicionar Comprovante</div>
                        </v-layout>
                    </v-card>
                </div>
              </template>
              <template v-else>
                <div v-if="!imagemAnexada && !arquivoAnexado">
                  <object v-if="this.fatura.comprovante_pagamento.indexOf('png') === -1" width="400" height="400" type="application/pdf" :data="fatura.comprovante_pagamento" @click="$refs.imageInput.click()"></object>
                  <img v-else alt="imagem do comprovante" :src="this.fatura.comprovante_pagamento" width="300" @click="$refs.imageInput.click()">
                </div>
              </template>
            <input
                type="file"
                style="display:none"
                accept="image/pdf*"
                ref="imageInput"
                @input="anexar"
            />
            </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!imagemAnexada && !arquivoAnexado" class="mb-3" color="primary" @click="$refs.imageInput.click()">Anexar</v-btn>
            <v-btn v-else class="mb-3" color="primary" @click="inserir">Confirmar</v-btn>
             <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
  props: ['fatura'],
  data () {
    return {
      arquivoAnexado: null,
      imagemAnexada: null
    }
  },
  methods: {
    anexar (event) {
      this.arquivoAnexado = null
      this.imagemAnexada = null
      let file = event.target.files[0]
      let reader = new FileReader()
      reader.onload = event => {
        let arquivo = event.target.result
        if (file.type.indexOf('image/') !== -1) {
          this.imagemAnexada = arquivo
        } else {
          this.arquivoAnexado = arquivo
        }
      }
      if (file) {
        reader.readAsDataURL(file)
      }
    },
    inserir () {
      this.$store.dispatch('inserirArquivoFirebase', {
        prefixo: 'comprovante',
        id: this.fatura.id,
        local: 'faturas',
        arquivo: this.imagemAnexada ? this.imagemAnexada : this.arquivoAnexado,
        tipo: this.imagemAnexada ? 'png' : 'pdf'
      }).then(downloadURL => {
        this.$store.dispatch('inserirComprovante', {
          comprovante_pagamento: downloadURL,
          id: this.fatura.id
        })
      }).then(() => {
        this.$emit('success', 'Comprovante inserido com sucesso.')
        this.fechar()
      }).catch(() => {
        this.$emit('error', 'Não foi possível inserir seu comprovante')
      })
    },
    fechar () {
      this.$emit('fechar')
      this.limparCampos()
    },
    limparCampos () {
      this.arquivoAnexado = null
      this.imagemAnexada = null
    }
  }
}
</script>
